import { lazy } from 'react';
import { authRoles } from '@/app/auth';

const DsiInformationPage = lazy(() => import('./DsiInformationPage'));

const DsiInformationConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.AllUsers,
  routes: [
    {
      path: 'terms/:token',
      element: <DsiInformationPage />,
    },
  ],
};

export default DsiInformationConfig;
